module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Logotipo-Vertical-Original.6aa942df.svg";